import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'date'
})
export class CustomDatePipe extends DatePipe implements PipeTransform{
  override transform(value: any, args?: any, timezone?: any): any {
    if (value === undefined || value === '' || value === null) {
      return ;
    }

    if (args === undefined) {
      args = 'shortDate';
    }

    if (value.toString().length === 10) {
      value = value + 'T12:00:00.000+00:00';
    }

    if (value.toString().length === 19) {
      value = value + '.000+00:00';
    }

    if (value.toString().length === 16) {
      value = value + ':00.000+00:00';
    }

    if (value.toString().length === 29 || value.toString().length === 24) {
      return super.transform(value, args, timezone);
    } else {
      //  En caso que no sea la longitud esperada, mando a mostrar lo que se envio sin formato
      return value + ' *';
    }
  }

  setMiddayTime(datetime: any) {
    datetime.setHours(12 - new Date().getTimezoneOffset() / 60);
    return datetime.toISOString();
  }
}
